import { useEffect, useState } from "react";
import { getCandidateDashboard } from "../api/candidateDashboard.api";
import { CandidateDashboardResponse } from "../types/candidateDashboard.types";

export default function useCandidateDashboard() {
  const [dashboard, setDashboard] = useState<CandidateDashboardResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");

  const fetchDashboard = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await getCandidateDashboard();
      setDashboard(response.data);
    } catch (error: any) {
      console.error("Dashboard Error:", error.response?.data || error);

      setError(
        error.response?.data?.message || "Unable to load dashboard"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  return {
    dashboard,
    loading,
    error,
    refresh: fetchDashboard,
  };
}